import { Position } from '../../types/Geometry';

export enum MapItemType {
  Takeoff = 'takeoff',
  Waypoint = 'waypoint'
}

export interface MapItem {
  type: MapItemType;
  index?: number;
  position: Position;
}
